import { render, staticRenderFns } from "./Tocbot.vue?vue&type=template&id=4dde3dcf&"
import script from "./Tocbot.vue?vue&type=script&lang=js&"
export * from "./Tocbot.vue?vue&type=script&lang=js&"
import style0 from "./Tocbot.vue?vue&type=style&index=0&id=4dde3dcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports